const ChannelDependencyLabel = Object.freeze({
  PublishTemplate_AndroidPush_Channel_Dependency: 'android_push',
  PublishTemplate_Email_Channel_Dependency: 'email',
  PublishTemplate_Facebook_Channel_Dependency: 'facebook',
  PublishTemplate_InApp_Channel_Dependency: 'inapp',
  PublishTemplate_InAppAndroid_Channel_Dependency: 'inapp_android',
  PublishTemplate_InAppIos_Channel_Dependency: 'inapp_ios',
  PublishTemplate_Inbox_Channel_Dependency: 'inbox',
  PublishTemplate_IosPush_Channel_Dependency: 'ios_push',
  PublishTemplate_Onsite_Channel_Dependency: 'onsite',
  PublishTemplate_Sms_Channel_Dependency: 'sms',
  PublishTemplate_Whatsapp_Channel_Dependency: 'whatsapp',
  PublishTemplate_Webhook_Channel_Dependency: 'webhook',
  PublishTemplate_WebPush_Channel_Dependency: 'web_push'
})

const FeatureDependencyLabel = Object.freeze({
  PublishTemplate_GoogleAdRetarget_Feature_Dependency: 'googleads',
  PublishTemplate_MetaAdRetarget_Feature_Dependency: 'meta',
  PublishTemplate_Throttling_Feature_Dependency: 'throttling',
  PublishTemplate_CustomerIntelligence_Feature_Dependency:
    'customer_intelligence_templates',
  PublishTemplate_Microsites_Feature_Dependency: 'microsites',
  PublishTemplate_Promotions_Feature_Dependency: 'promotion',
  PublishTemplate_RollingSegments_Feature_Dependency: 'rolling_segments',
  PublishTemplate_SeedList_Feature_Dependency: 'seed_list_enabled',
  PublishTemplate_Workflow_Feature_Dependency: 'maxautomation'
})

export { ChannelDependencyLabel, FeatureDependencyLabel }



// WEBPACK FOOTER //
// ./src/modules/campaigns/enum/CampaignTemplateDependencyLabelEnum.js